import { type Plugin } from 'vue';
import { ArcElement, Chart, DoughnutController, Tooltip } from 'chart.js';

export const setupChartjs: () => Plugin = () => ({
    install: (): void => {
        Chart.register(ArcElement, DoughnutController, Tooltip);
    }
});